import { GoogleReviewData } from 'constants/dataTypes';
import Image from 'next/image';
import { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getRelativeTime } from 'utils/common.utils';


interface DetailedReviewPopupProps {
    onClose: () => void;
    review: GoogleReviewData;
  }
  
export const DetailedReviewPopup: React.FC<DetailedReviewPopupProps> = ({ onClose, review }) => {
    const popupRef = useRef<HTMLDivElement>(null);
  
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
          onClose();
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [onClose]);
  
    return createPortal(
      <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
        <div ref={popupRef} className="bg-white p-6 rounded-lg max-w-lg w-full relative">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-[#959595] hover:text-gray-800 transition-colors bg-gray-200 hover:bg-gray-300 rounded-full p-1"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className="text-center">
            <div className="flex items-start mb-4">
              <div className="bg-gray-300 h-16 w-16 overflow-hidden rounded-full">
                <Image
                  src={review.reviewer_profilePhotoUrl}
                  alt={review.reviewer_displayName}
                  width={48}
                  height={48}
                  className="object-cover"
                />
              </div>
              <div className="ml-4 flex-grow text-left">
                <div className="text-base font-medium">{review.reviewer_displayName}</div>
                <div className="text-xs text-[#959595]">{getRelativeTime(review.create_date)}</div>
              </div>
              <div className="flex flex-col items-end ml-4">
              <span className="mr-2 text-sm text-[#959595] mt-3">{review.starRating} out of 5</span>
                <div className="flex items-center mb-1">
                  <span className="text-[#FBBB06] flex">
                    {Array.from({ length: review.starRating }).map((_, index) => (
                      <svg key={index} width="15" height="15" viewBox="0 0 24 24" fill="currentColor" className="mr-1">
                        <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.888 1.516 8.306L12 18.902l-7.452 4.598 1.516-8.306-6.064-5.888 8.332-1.151z"/>
                      </svg>
                    ))}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-4 text-left text-[15px]">
              <p>{review.review}</p>
            </div>
            <div className="mt-6 flex justify-center">
              <button
                onClick={onClose}
                className="px-6 py-2 bg-[#2A2A2A] text-white rounded-md transition-colors "
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  };